import React from "react";

import "../styles/arrow.scss";

const Arrow = props => {
  return (
    <div className="arrow" style={{ left: props.x, bottom: props.y }}>
      <div className="arrow--head" />
      <div
        className={"arrow--tail arrow--tail--" + props.direction}
        style={{ height: props.length + "vw" }}
      />
    </div>
  );
};

export default Arrow;
